const ACTIVE_STATUSES = new Set(['active', 'trialing', 'valid']);

export const isSubscriptionActive = (subscription) => {
    if (!subscription) return false;
    const status = String(subscription.status ?? subscription.stripe_status ?? '').toLowerCase();
    return ACTIVE_STATUSES.has(status);
};

export const hasActiveSubscriptionFromApi = (data) => isSubscriptionActive(data?.subscription);

export const isActivityFree = (activity) => (
    activity?.isFree === 1 || activity?.isFree === true
);

/**
 * Mirrors app logic: free content needs login only; premium needs active/trialing subscription.
 * Staff with canManageActivities can preview without subscribing.
 */
export const canAccessActivityMedia = ({
    isAuthenticated,
    canBypass = false,
    activityIsFree,
    hasActiveSubscription,
}) => {
    if (canBypass) return true;
    if (!isAuthenticated) return false;
    if (activityIsFree) return true;
    return Boolean(hasActiveSubscription);
};
